(function() {
  var modal;
  var pendingForm = null;
  var pendingButton = null;

  function init() {
    modal = new theme.Modals('ProductNoticeModal', 'product-notice-modal', {
      closeOffContentClick: true
    });

    // Product page: intercept form submit
    document.addEventListener('submit', handleFormSubmit, true);

    // Modal confirm button
    var confirmBtn = document.getElementById('ProductNoticeConfirm');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', handleConfirm);
    }

    // Expose for collection grid buttons (group-products.liquid)
    window.__productNotice = {
      showForButton: showForButton
    };
  }

  // --- Product page form submit flow ---

  function handleFormSubmit(evt) {
    var form = evt.target;
    if (!form || form.tagName !== 'FORM') return;

    var noticeInput = form.querySelector('[data-product-notice]');
    if (!noticeInput) return;

    // Already acknowledged — let it through
    if (form.dataset.noticeAcknowledged === 'true') return;

    evt.preventDefault();
    evt.stopPropagation();

    var noticeText = noticeInput.getAttribute('data-product-notice');
    showModal(noticeText);

    pendingForm = form;
    pendingButton = null;
  }

  // --- Collection grid button click flow ---

  function showForButton(btn, noticeText) {
    showModal(noticeText);
    pendingButton = btn;
    pendingForm = null;
  }

  // --- Shared ---

  function showModal(text) {
    var modalText = document.getElementById('ProductNoticeModalText');
    if (modalText) {
      modalText.textContent = text;
    }
    modal.open();
  }

  function handleConfirm() {
    modal.close();

    if (pendingForm) {
      // Product page flow
      pendingForm.dataset.noticeAcknowledged = 'true';
      var submitBtn = pendingForm.querySelector('[data-add-to-cart]');
      if (submitBtn) {
        submitBtn.click();
      } else {
        pendingForm.submit();
      }
      pendingForm = null;
    } else if (pendingButton) {
      // Collection grid flow — mark acknowledged then re-click
      pendingButton.dataset.noticeAcknowledged = 'true';
      pendingButton.click();
      pendingButton = null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
